import { render } from "./BirthdayRequest.vue?vue&type=template&id=07978e40"
import script from "./BirthdayRequest.vue?vue&type=script&lang=js"
export * from "./BirthdayRequest.vue?vue&type=script&lang=js"

import "./BirthdayRequest.vue?vue&type=style&index=0&id=07978e40&lang=css"
script.render = render

export default script